module.exports = __webpack_public_path__ + "static/media/sdg_icon_8.a441c553.png";